export default __webpack_public_path__ + "static/media/not-found.94fd1695.jpg";